// src/hooks/useInvites.js
import { useState, useEffect } from "react";
import { message, Modal } from "antd";
import { fetchInvites, sendInvite } from "PlatForms/OrgLMS/Services/ManagerService/inviteService";
import { resendInvite } from "PlatForms/OrgLMS/Services/ManagerService/inviteService";

export const useInvites = () => {
  const [invites, setInvites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getInvites = async () => {
    try {
      setLoading(true);
      const data = await fetchInvites();
      setInvites(data);
    } catch (err) {
      setError(err);
      message.error("Failed to fetch invites");
    } finally {
      setLoading(false);
    }
  };

  const handleResend = (inviteId) => {
    let modal = null; // reference for updating modal props

    modal = Modal.confirm({
      title: "Are you sure you want to resend the invitation?",
      content: "This will resend the invitation to the user.",
      okText: "Resend",
      cancelText: "Cancel",
      okButtonProps: {
        loading: false, // initial loading false
      },
      onOk: async () => {
        try {
          modal.update({
            okButtonProps: { loading: true },
          });

          await resendInvite(inviteId)

          message.success("Invitation resent successfully!");
          await getInvites();
        } catch (error) {
          console.log("Error", error);
        } finally {
          modal.update({
            okButtonProps: { loading: false },
          });
        }
      },
    });
  };

  const handleSendInvite = async (inviteData) => {
    try {
      const response = await sendInvite(inviteData);
      await getInvites();
      return { success: true, data: response };
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          return { success: false, error: data };
        }
      }
      throw error;
    }
  };

  useEffect(() => {
    getInvites();
  }, []);

  return {
    invites,
    loading,
    error,
    getInvites,
    handleResend,
    handleSendInvite,
  };
};
